import styles from "./EmptyState.module.scss";

const EmptyState = () => {
  return (
    <div className={styles.emptyContainer}>
      <div className={styles.emptyIcon}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M9 11H15M9 15H15M17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3Z" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h3 className={styles.emptyTitle}>No Requests Found</h3>
      <p className={styles.emptyText}>
        There are no requests matching your current filters. Try adjusting your search criteria or check back later.
      </p>
    </div>
  );
};

export default EmptyState; 